// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1XbkQ","signatureBlock":"Footer_signatureBlock__2jxRM","signature":"Footer_signature__2MQ7O"};